import { useNavigate } from 'react-router-dom';
import { Card } from '@core/components/Card';
import { Button } from '@core/components/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-page">
      <Card className="text-center py-8 max-w-sm w-full">
        <div className="text-6xl mb-4">🔍</div>
        <h1 className="text-2xl font-bold text-text-main mb-2">Страница не найдена</h1>
        <p className="text-text-muted mb-6">
          Проверьте URL или вернитесь на главную
        </p>
        <Button onClick={() => navigate('/')}>
          На главную
        </Button>
      </Card>
    </div>
  );
}
